import React, {PureComponent} from 'react'
import {inject} from 'mobx-react'
import Store from 'Store'
import {User, Role} from '../Model'
import {Branch} from 'modules/Branches/Model'
import {rules} from 'helpers/Validation'
import {t} from 'helpers/i18n'
import {Form} from 'components'
import {IField, FieldType} from 'elements'
import {loading} from 'elements/Loading'

interface Props {
  store?: Store
  match: any // tslint:disable-line:no-any
  user: User
  branches: Branch[]
}

@inject('store')
@loading<Props>(props => [
  props.match.params.id
    ? props.store!.users.read(props.match.params.id).then(user => ({user}))
    : undefined,
  props.store!.branches.read().then(branches => ({branches}))
])
class UserForm extends PureComponent<Props, object> {
  fields = [
    {
      name: 'name',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 4
    },
    {
      name: 'lastname',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 6
    },
    {
      name: 'username',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 4
    },
    {
      name: 'password',
      type: FieldType.Password,
      rules: rules()
        .string()
        .required(),
      size: 3
    },
    {
      name: 'role',
      type: FieldType.Select,
      rules: rules()
        .string()
        .required(),
      options: [Role.Administrator, Role.Seller, Role.Supervisor].map(item => {
        console.log(item)
      // options: ['super', 'admin', 'sel'].map(item => {
        return {name: t(item), value: item}
      }),
      size: 4
    },
    {
      name: 'address',
      type: FieldType.Text,
      rules: rules().string(),
      size: 5
    },
    {
      name: 'zip',
      type: FieldType.Number,
      rules: rules()
        .number()
        .integer(),
      size: 2
    },
    {
      name: 'city',
      type: FieldType.Text,
      rules: rules().string(),
      size: 2
    },
    {
      name: 'province',
      type: FieldType.Text,
      rules: rules().string(),
      size: 2
    },
    {
      name: 'email',
      type: FieldType.Text,
      rules: rules().string(),
      size: 4
    },
    {
      name: 'phone',
      type: FieldType.Number,
      rules: rules()
        .string(),
      size: 2
    },
    this.props.store!.users.user.isRetail
      ? {
          name: 'branch',
          type: FieldType.Select,
          rules: rules()
            .number()
            .integer()
            .required(),
          options: this.props.branches.map(branch => {
            return {name: branch.name, value: String(branch.id)}
          }),
          size: 4
        }
      : undefined
  ]
  render() {
    const {user} = this.props
    if (user) user.password = '********'
    const users = this.props.store!.users

    // console.log('user', user)

    return (
      <Form
        loading={['post@user/', 'put@user/']}
        fields={this.fields}
        values={user}
        store={users}
      />
    )
  }
}

export default UserForm



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Users/containers/UserForm.tsx